const IntroductionSection = () => {
  return (
    <section className="w-full bg-gray-50 py-16 px-6 lg:px-16">
      <div className="max-w-7xl mx-auto text-center space-y-6">
        <h1 className="text-2xl lg:text-5xl font-bold text-gray-800">
          Chào mừng đến với Cửa Hàng Apple Uy Tín
        </h1>
        <p className="text-lg lg:text-xl text-gray-600">
          Với sứ mệnh mang sản phẩm Apple chính hãng, chất lượng cao đến với mọi
          người, chúng tôi cam kết đem lại trải nghiệm mua sắm tuyệt vời và dịch
          vụ hỗ trợ chuyên nghiệp nhất.
        </p>
        <img
          src={
            "https://res.cloudinary.com/dyxwbtohw/image/upload/v1735612447/AboutUs/o00mnbuid7lj7qh0vsg8.jpg"
          }
          alt="Store Front"
          className="w-full lg:w-2/3 mx-auto rounded-lg shadow-lg"
        />
      </div>
    </section>
  );
};

export default IntroductionSection;
